import {
  Modal,
  ModalOverlay,
  ModalCloseButton,
  ModalHeader,
  ModalContent,
  ModalBody,
  Text,
  Button,
  ModalFooter,
} from '@chakra-ui/react';
import { useMarkAllReadMutation } from '@/store/query/notification';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useDispatch } from 'react-redux';
import { clearNotification } from '@/store/notification';
import { ModalWithForm } from '@/components/ats';
import { useKFlags } from '@/hooks/use-k-flags';

export const MarkAllRead = ({
  isOpen = false,
  onClose = () => {},
  onToggleUnRead = () => {},
  setPagination = () => {},
}) => {
  const [markAllRead, { isLoading }] = useMarkAllReadMutation();
  const dispatch = useDispatch();
  const { track } = useMixpanel();
  const { ats_enabled } = useKFlags();
  const onMarkAllRead = async () => {
    try {
      await markAllRead();
      await dispatch(clearNotification());
      onToggleUnRead();
      setPagination(0);
      track({
        module: 'in-app-notification',
        data: {
          'user-event': 'click',
          'user-action': 'mark-all-read',
          'marked-as-read': true,
        },
      });
      onClose();
    } catch {}
  };

  if (ats_enabled) {
    return (
      <>
        {isOpen && (
          <ModalWithForm
            withForm={false}
            isOpen={isOpen}
            onClose={onClose}
            headerText="Marking as read is permanent"
            subHeaderText="Once a notification is marked as read, it cannot be undone"
            primaryCtaText="Confirm"
            handleSubmit={onMarkAllRead}
            isCtaLoading={isLoading}
          />
        )}
      </>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          <Text size="lg-semi-bold">
            Marking read is an irreversible action.
          </Text>
        </ModalHeader>
        <ModalBody data-test-id="in-notification-mark-all-as-read-modal">
          <Text size="sm" variant="muted">
            You cannot mark any notification as unread once they are marked
            read.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="secondary"
            mr="8px"
            onClick={() => {
              onClose();
              track({
                module: 'in-app-notification',
                data: {
                  'user-event': 'click',
                  'user-action': 'mark-all-read',
                  'marked-as-read': false,
                },
              });
            }}
            data-test-id="secondary-cta-button"
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
            loadingText="Submitting"
            isLoading={isLoading}
            onClick={onMarkAllRead}
            data-test-id="primary-cta-button"
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
